import { TipoCliente } from '@acme/core'
import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import {
    Cliente,
    clientes as clientes_api,
    EditarClienteSchema,
} from 'service/api'
import { toast } from 'sonner'
import { EditarClienteForm } from '../forms/EditarCliente'
import FormContato from '../forms/FormContato'
import PlanoDiferenciado from './PlanoDiferenciado'

type OutletContext = {
    clientes?: Cliente[]
}

export default function EditarCliente() {
    const navigate = useNavigate()
    const { id } = useParams()
    const { clientes } = useOutletContext<OutletContext>()
    const {
        decoded: { categoria },
    } = useAuth()
    const toggle = () => navigate('/administracao/clientes')

    const { mutateAsync, isLoading } = clientes_api.mutations.useUpdate({
        onSuccess: () => {
            toast.success('Cliente atualizado com sucesso!')
        },
        onError: err => {
            toast.error(err.message)
        },
        invalidateQuery: true,
    })

    const cliente = clientes?.find(c => c.id === +id!)
    if (!cliente) return null

    const isRepresentante = cliente.tipo === TipoCliente.REPRESENTANTE,
        existePlanoDiferenciado = cliente.PlanoDiferenciado

    return (
        <TabbedDialog.Root
            open={hasPermission(['update', 'Clientes'])}
            onClose={toggle}
            width="42rem"
            loading={isLoading}
            onSubmit={values =>
                mutateAsync({ id: cliente.id, ...values }).catch(e => {
                    toast.error(e.message)
                    throw e
                })
            }
            schema={EditarClienteSchema}
            defaultValues={{
                ...cliente,
                PlanoDiferenciado: {
                    ...cliente.PlanoDiferenciado,
                    editar: !existePlanoDiferenciado,
                },
                existePlanoDiferenciado,
                emailResponsavel: (cliente as any).email,
            }}
            tabs={[
                {
                    name: 'dados',
                    label: 'Dados do cliente',
                    content: (
                        <EditarClienteForm
                            faixaAtual={cliente.limiteFuncionarios ?? 0}
                        />
                    ),
                },
                ...(isRepresentante
                    ? [
                          {
                              name: 'contato',
                              label: 'Contato',
                              content: <FormContato placeholders={cliente} />,
                          },
                      ]
                    : [1, 7].includes(categoria)
                      ? [
                            {
                                name: 'plano',
                                label: 'Plano diferenciado',
                                content: <PlanoDiferenciado />,
                            },
                        ]
                      : []),
            ]}
        >
            <TabbedDialog.Title>
                Editar {isRepresentante ? 'representante' : 'cliente'}
            </TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
        </TabbedDialog.Root>
    )
}
